import { render, staticRenderFns } from "./QuizListPage.vue?vue&type=template&id=0bded6bf&scoped=true"
import script from "./QuizListPage.vue?vue&type=script&lang=js"
export * from "./QuizListPage.vue?vue&type=script&lang=js"
import style0 from "./QuizListPage.vue?vue&type=style&index=0&id=0bded6bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bded6bf",
  null
  
)

export default component.exports